import React from 'react';
import _ from "lodash";
import {connect} from "react-redux";

import {Grid} from "@material-ui/core";
import {PrimaryButton} from "../../../../components/Buttons";

import DepotSelectionModal from "../DepotSeletionModal";
import {updateCustomerTradingData} from "../../../../components/TradingStore/actions";
import {portfolioBuilderPossible} from "../../utils";

export const SelectCustomerDepotsForPortfolioBuilderModal = connect()((props) => {
  const {banksData, customerId, instrumentsData, completlySold, onClose, open, onGoToTradeDetails, onlyDepots} = props;

  const depots = React.useMemo(() => {
    const active = instrumentsData.data || [];
    const inactive = completlySold.data || [];

    return _.uniqBy(active.concat(inactive), 'id').map(
      (depot) => {
        return {
          ...depot,
          disabled: !portfolioBuilderPossible(depot, banksData),
          disabledReason: 'Der Portfolio Builder wird von dieser Depotstelle oder Depotart nicht unterstützt.'
        }
      })
  }, [instrumentsData.updatedAt, completlySold.updatedAt]);

  const [selectedItems, setSelectedItems] = React.useState({});

  if (!open) {
    return null
  }

  const handleContainerCheckboxChange = (depot) => {
    setSelectedItems({[depot.id]: depot});
  };

  const handleCreate = () => {
    props.dispatch(updateCustomerTradingData(customerId, {
      autoPortfolioBuilder: selectedDepot.id
    }));

    onGoToTradeDetails()
  };

  const selectedDepot = Object.values(selectedItems)[0];

  return (
    <>
      <DepotSelectionModal
        open={open}
        onClose={onClose}
        title={'Depot zum Optimieren durch den Portfolio Builder auswählen'}
        subHeader={'Der Portfolio Builder ist ein digitales Werkzeug zur Unterstützung der Anlageberatung. Er ermöglicht die Erstellung und Optimierung individueller Anlagevorschläge unter Berücksichtigung von Risikoprofilen sowie Ein- und Auszahlungen. Grundlage ist ein kapitalmarktbasiertes Modell, das bisher institutionellen Investoren vorbehalten war und fundierte, modellgestützte Entscheidungen im Beratungsprozess erlaubt.'}
        instrumentsData={instrumentsData}
        depots={depots}
        onlyDepots={onlyDepots}
        selectedItems={selectedItems}
        handleContainerCheckboxChange={handleContainerCheckboxChange}
        singleSelection
        actions={
          <Grid xs={12} sm={"auto"} item>
            <PrimaryButton
              text='Anlageberatung starten'
              disabled={!selectedDepot}
              onButtonClick={handleCreate}
              style={{width: '100%'}}
            />
          </Grid>
        }
      />
    </>
  )
});